/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { FindOrCreateUser200ResponseData } from './FindOrCreateUser200ResponseData'
import {
  FindOrCreateUser200ResponseDataFromJSON,
  FindOrCreateUser200ResponseDataFromJSONTyped,
  FindOrCreateUser200ResponseDataToJSON,
} from './FindOrCreateUser200ResponseData'

/**
 *
 * @export
 * @interface FindOrCreateUser200Response
 */
export interface FindOrCreateUser200Response {
  /**
   *
   * @type {boolean}
   * @memberof FindOrCreateUser200Response
   */
  status: boolean
  /**
   *
   * @type {FindOrCreateUser200ResponseData}
   * @memberof FindOrCreateUser200Response
   */
  data: FindOrCreateUser200ResponseData
}

/**
 * Check if a given object implements the FindOrCreateUser200Response interface.
 */
export function instanceOfFindOrCreateUser200Response(
  value: object
): value is FindOrCreateUser200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function FindOrCreateUser200ResponseFromJSON(
  json: any
): FindOrCreateUser200Response {
  return FindOrCreateUser200ResponseFromJSONTyped(json, false)
}

export function FindOrCreateUser200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FindOrCreateUser200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: FindOrCreateUser200ResponseDataFromJSON(json['data']),
  }
}

export function FindOrCreateUser200ResponseToJSON(
  value?: FindOrCreateUser200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: FindOrCreateUser200ResponseDataToJSON(value['data']),
  }
}
